import { CdkFixedSizeVirtualScroll, CdkVirtualForOf, CdkVirtualScrollViewport } from "@angular/cdk/scrolling";
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatRippleModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSliderModule } from "@angular/material/slider";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatTreeModule } from "@angular/material/tree";
import { TranslateModule } from "@ngx-translate/core";
import { DirectivesModule } from "../../providers/directives/directives.module";
import { PipesModule } from "../../providers/pipes/pipes.module";
import { OpenDialogService } from "../../providers/service/open-dialog.service";
import { FloatingButtonsComponent } from "../../widget/floating-buttons/floating-buttons.component";
import { ChartBoxModule } from "../chart-box/chart-box.module";
import { MapsComponentModule } from "../maps-component/maps-component.module";
import { ChartDataTypesComponent } from './chart-data-types/chart-data-types.component';
import { ChartDialogComponent } from './chart-dialog/chart-dialog.component';
import {ReactiveFormsModule} from "@angular/forms";
import {WidgetModule} from "../../widget/widget.module";
import {BoxesModule} from "../../boxes/boxes.module";
import { ChooseComponent } from './choose/choose.component';
import { FormByHtmlDataObjFormComponent } from './form-by-html-data-obj-form/form-by-html-data-obj-form.component';
import { InviteUserComponent } from './invite-user/invite-user.component';
// import { IotDeviceConfigurationComponent } from './iot-device-configuration/iot-device-configuration.component';
import { NotificationsDetailsComponent } from './notifications-details/notifications-details.component';
import { PossibleCommandsComponent } from './possible-commands/possible-commands.component';
import { SearchPointComponent } from './search-point/search-point.component';
import { SelectDateComponent } from './select-date/select-date.component';
import { SelectWithChipsComponent } from "./select-with-chips/select-with-chips.component";
import { SensorEventFormComponent } from './sensor-event-form/sensor-event-form.component';
import { SensorsListComponent } from './sensors-list/sensors-list.component';
import { SetThermostatComponent } from './set-thermostat/set-thermostat.component';
import { ShowRawDetailComponent } from './show-raw-detail/show-raw-detail.component';
import { TwoFaCodeDialogComponent } from './two-fa-code-dialog/two-fa-code-dialog.component';
import { TwoFaConfirmationComponent } from './two-fa-confirmation/two-fa-confirmation.component';
import { UpdateElementComponent } from './update-element/update-element.component';
import { UpdateIotConfigurationComponent } from './update-iot-configuration/update-iot-configuration.component';
import { UpdateIotDeviceComponent } from './update-iot-device/update-iot-device.component';
import { UpdateIotPidConfigurationsComponent } from './update-iot-pid-configurations/update-iot-pid-configurations.component';
import { MultipleActionsComponent } from './multiple-actions/multiple-actions.component';

@NgModule({
  declarations: [
    ChooseComponent,
    SelectWithChipsComponent,
    ChartDialogComponent,
    SetThermostatComponent,
    UpdateElementComponent,
    PossibleCommandsComponent,
    UpdateIotDeviceComponent,
    // IotDeviceConfigurationComponent,
    UpdateIotConfigurationComponent,
    FormByHtmlDataObjFormComponent,
    ChartDataTypesComponent,
    SelectDateComponent,
    ShowRawDetailComponent,
    SearchPointComponent,
    InviteUserComponent,
    SensorEventFormComponent,
    SensorsListComponent,
    NotificationsDetailsComponent,
    UpdateIotPidConfigurationsComponent,
    TwoFaConfirmationComponent,
    TwoFaCodeDialogComponent,
    MultipleActionsComponent,
  ],
  imports: [
    CommonModule,
    MatCardModule,
    TranslateModule,
    MatRippleModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    WidgetModule,
    MatProgressBarModule,
    MatTabsModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    BoxesModule,
    MatRadioModule,
    MatDatepickerModule,
    PipesModule,
    MapsComponentModule,
    DirectivesModule,
    MatButtonToggleModule,
    MatCheckboxModule,
    MatChipsModule,
    MatListModule,
    MatExpansionModule,
    MatIconModule,
    MatButtonModule,
    MatSliderModule,
    MatDialogModule,
    ChartBoxModule,
    MatMenuModule,
    MatSidenavModule,
    MatTreeModule,
    CdkVirtualScrollViewport,
    CdkVirtualForOf,
    CdkFixedSizeVirtualScroll,
    FloatingButtonsComponent,
    FormsModule,
  ],
  providers: [OpenDialogService],
  exports: [ChooseComponent, SelectWithChipsComponent, MultipleActionsComponent],

})
export class PopUpComponentModule {}
